/* Creazione del popup con le informazioni dei layer */
import { useLeaflet } from "react-leaflet";
import "leaflet.locatecontrol";
import { memo } from "react";
import L from "leaflet";
import './ClickOnMap.css'
import * as WMS from "leaflet.wms";
import { changepositionStart,changepositionEnd,selectNewMarkerStart2, selectNewMarkerEnd2,changeNomeFermataStart,changeNomeFermataEnd, changePercorsoDrawer,changePercorsoTariffa,changePositionTariffaStart,changePositionTariffaEnd, changePolyReal,changeLineaRealTime,changeAziendaRealTime,changeRegioneAereoPartenza,changeRegioneAereoArrivo, changeLayerDrawer, changeLayerInformation,changeLayerDiv, changeArrayLayer, changeLatLongLayer,changeMappa} from "../../redux";
import { connect } from 'react-redux'
import popupImg from './popup.svg'
import removeOldLayer from './RemoveOldLayer'
import createDiv from './CreateDiv'
import CreateContainer from "./CreateContainer";
import DrawerLayer from "./DrawerLayer";
import {useTranslation} from 'react-i18next'
import { layer } from "leaflet.wms";
import { setPageStateUpdate } from "@material-ui/data-grid";
import axios from 'axios'
import { CircularProgress } from "@material-ui/core";
import React from 'react';

const ClickOnMap = (props) => {
  const {t} = useTranslation()
  
  const { map } = useLeaflet()
  
  //var container = L.DomUtil.create('div','custom');
  var allLayers = []
  
  var savePoint = {lat : 0, lng : 0}
  var icon = L.icon({
    iconUrl: popupImg,
    iconSize:     [30, 40],
    iconAnchor:   [15  , 35],
    popupAnchor:  [0, -35]
  });
  
  //Rimozione del marker quando chiudo popup
  map.on('popupclose', function(e) {
      removeOldLayer(map)
  });
  const ClickMap = function (e){map.off('click',ClickMap)} 
  
    // attivazione popup quando layer non presente
      //map.on('click',ClickMap
    
   
    /* removeOldLayer(map);
    createDiv([],container,e.latlng,props,map)

    L.marker(e.latlng,{icon:icon,nome: "position"})
    .addTo(map)
    .bindPopup(container)
    .openPopup()  */
    
  //)       
/*  WMS.Source.include({
  'getIdentifyLayers': function() {
    
    // Hook to determine which layers to identify
    if (this.options.identifyLayers)
        return this.options.identifyLayers;
    return Object.keys(this._subLayers);
  },
  'identify' : function(evt){

    var layers = ["Aeroporti"];
        if (!layers.length) {
            return;
        }
        this.getFeatureInfo(
            evt.containerPoint, evt.latlng, layers,
            this.showFeatureInfo
        );
        

    
  }
  
})     */

//Chiamata getCapabilities 
 WMS.Source.include({
  
   
      'getIdentifyLayers': function() {
        
        // Hook to determine which layers to identify
        if (this.options.identifyLayers) return this.options.identifyLayers;
        return Object.keys(this._subLayers);
        
      },
      'identify' : function(evt){
        
        var layers = this.getIdentifyLayers()
        
        if (!layers.length) return;
        if(layers[0] === "init")  this.showFeatureInfo(evt.latlng);
        else this.getFeatureInfo(evt.containerPoint, evt.latlng, layers,this.showFeatureInfo);
      },
      'getFeatureInfo': async function(point, latlng, layers, callback) {
       
        // Request WMS GetFeatureInfo and call callback with results
        // (split from identify() to faciliate use outside of map events)
        var params = this.getFeatureInfoParams(point, layers),
        url = this._url + L.Util.getParamString(params, this._url);

        this.showWaiting();
        //this.ajax(url, done);
        //let result = 
        axios.get(url,{headers: window.tp_headers}).then(result => setTimeout(() =>{
          this.hideWaiting();
            //var text = this.parseFeatureInfo(result, url);
          try {
            //var resultParsed = JSON.parse(result.data)
            callback.call(this, latlng, result.data,params,url,this._url);
          } catch (error) {
            console.error('error',error)
            var resultParsedError = {features : [], numberReturned : 0}
            callback.call(this, latlng, resultParsedError,params,url,this._url);
          }
        }),1000)
        
        /*
        function done(result) {
          
            this.hideWaiting();
            //var text = this.parseFeatureInfo(result, url);
            try {
              var resultParsed = JSON.parse(result)
              callback.call(this, latlng, resultParsed,params,url,this._url);
            } catch (error) {
              console.error('error',error)
              var resultParsedError = {features : [], numberReturned : 0}
              callback.call(this, latlng, resultParsedError,params,url,this._url);
            }            
        }*/
    },
      'showFeatureInfo': function(latlng, info,params,url,this_url) {
        // Hook to handle displaying parsed AJAX response to the user
        if (!this._map) {
            return;
        }

        // AGGIUNTO
        let latlngFeature = latlng
        if(info !== undefined && info.numberReturned > 0){
          if(info.features[0].properties && info.features[0].properties.stop_lat) latlngFeature = {lat: info.features[0].properties.stop_lat, lng: info.features[0].properties.stop_lon}
          if(info.features[0].properties && info.features[0].properties.latitudine) latlngFeature = {lat: info.features[0].properties.latitudine, lng: info.features[0].properties.longitudine}
        }
        let container
        if (savePoint && savePoint.lat === latlng.lat && savePoint.lng === latlng.lng){ 
          if(info !== undefined && info.numberReturned > 0){
            //allLayers.push({nome: params.layers ,url: url, url_service: this_url, info : info})  
            allLayers[0]={nome: params.layers ,url: url, url_service: this_url, info : info} 
            props.changeLayerDrawer(false)                 
            props.changeArrayLayer(allLayers)
            props.changeLatLongLayer(latlng)
            //container = L.DomUtil.create('div','custom');

            container = createDiv( allLayers, latlngFeature,props,map)
            //removeOldLayer(map); 
  
            var oldMarker;
            map.eachLayer(element => {
              if ( element.options.nome === "position") oldMarker = element;
            })
            if (oldMarker) {
              oldMarker.bindPopup(container)
              var newLatLng = new L.LatLng(latlngFeature.lat, latlngFeature.lng);
              oldMarker.setLatLng(newLatLng); 
              if(!oldMarker.isPopupOpen()) oldMarker.openPopup()
            } else {
              L.marker(latlngFeature,{icon:icon, nome: "position", closeOnClick: false, autoClose: false})
              .addTo(map)
              .bindPopup(container)
              .openPopup()   
            }

          }
        }
        if (savePoint && savePoint.lat !== latlng.lat && savePoint.lng !== latlng.lng){ //point          
            savePoint = latlng //point
            //savePoint = latlngTEMP //point
            allLayers = []           
            if(info !== undefined && info.numberReturned > 0){
              //allLayers.push({nome: params.layers ,url: url, url_service: this_url, info : info})  
              allLayers[0]={nome: params.layers ,url: url, url_service: this_url, info : info}       
            } 
            props.changeLayerDrawer(false)   
            props.changeArrayLayer(allLayers)
            props.changeLatLongLayer(latlngFeature)
            //container = L.DomUtil.create('div','custom');
            container = createDiv( allLayers, latlngFeature,props,map)
            removeOldLayer(map);
            L.marker(latlngFeature,{icon:icon, nome: "position", closeOnClick: false, autoClose: false})
              .addTo(map)
              .bindPopup(container)
              .openPopup()   
        } 


       /*
        props.changeLayerDrawer(false)

        if(info !== undefined && info.numberReturned > 0){
          allLayers.push({nome: params.layers ,url: url, url_service: this_url, info : info})
         
        } 
        
        removeOldLayer(map);      
        
        props.changeArrayLayer(allLayers)
        props.changeLatLongLayer(latlng)
        var container = L.DomUtil.create('div','custom');
        createDiv( allLayers, container,latlng,props,map,t)
        L.marker(latlng,{icon:icon,nome: "position"})
          .addTo(map)
          .bindPopup(container)
          .openPopup()
        */
       // this._map.openPopup(JSON.stringify(info), latlng);
    }
      
      
    /* 'getFeatureInfo': async function(point, latlng, layers, callback) { 
    
    

          var myVar;
          var i;
          if (savePoint !== point){ //point
            console.log(savePoint,"savepoint")
              savePoint = point //point
              allLayers = []
          }
          console.log(savePoint,"savepoint")
            props.changeLayerDrawer(false)
            
            var params = this.getFeatureInfoParams(point, layers); //point

            var url = this._url + L.Util.getParamString(params, this._url);
            
            
              await axios.get(url).then(resp => {
              
              if(resp.data.numberReturned > 0){
                allLayers.push({nome: params.layers ,url: url, url_service: this._url})
               
              } 
              removeOldLayer(map);
            
              
              props.changeArrayLayer(allLayers)
              props.changeLatLongLayer(latlng)
              
              createDiv( allLayers, container,latlng,props,map,t)
              
              
              L.marker(latlng,{icon:icon,nome: "position"})
                .addTo(map)
                .bindPopup(container)
                .openPopup()
           
           
           
            
          }) 
            
         
            
         }    */
          
    })
    
    return null
  
   }; 



const mapStateToProps = state => {
    return {
        positionStart: state.positionStart,
        markerStart2: state.markerStart2,
        markerEnd2: state.markerEnd2,
        nomeFermataStart:state.nomeFermataStart,
        nomeFermataEnd: state.nomeFermataEnd,
        percorsoDrawer : state.percorsoDrawer,
        percorsoTariffa : state.percorsoTariffa,
        positionTariffaEnd : state.positionTariffaEnd,
        positionTariffaStart : state.positionTariffaStart,
        polyReal : state.polyReal,
        aziendaRealTime :state.aziendaRealTime,
        lineaRealTime:state.lineaRealTime,
        regioneAereoPartenza:state.regioneAereoPartenza,
        regioneAereoArrivo : state.regioneAereoArrivo,
        layerDrawer : state.layerDrawer,
        layerInformation : state.layerInformation,
        layerDiv : state.layerDiv,
        arrayLayer : state.arrayLayer,
        latLongLayer : state.latLongLayer,
        mappa:state.mappa
  
    }
  }
  
const mapDispatchToProps = dispatch => {
    return {
        changepositionStart: (positionStart) => dispatch(changepositionStart(positionStart)),
        changepositionEnd: (positionEnd) => dispatch(changepositionEnd(positionEnd)),
        markerStart2: (marker) => dispatch(selectNewMarkerStart2(marker)),
        markerEnd2: (marker) => dispatch(selectNewMarkerEnd2(marker)),
        changeNomeFermataStart :(nomeFermataStart) => dispatch(changeNomeFermataStart(nomeFermataStart)),
        changeNomeFermataEnd :(nomeFermataEnd) => dispatch(changeNomeFermataEnd(nomeFermataEnd)),
        changePercorsoDrawer : (percorsoDrawer) => dispatch(changePercorsoDrawer(percorsoDrawer)),
        changePercorsoTariffa : (percorsoTariffa) => dispatch(changePercorsoTariffa(percorsoTariffa)),
        changePositionTariffaStart : (positionTariffaStart) => dispatch(changePositionTariffaStart(positionTariffaStart)),
        changePositionTariffaEnd : (positionTariffaEnd) => dispatch(changePositionTariffaEnd(positionTariffaEnd)),
        changePolyReal : (polyReal) => dispatch(changePolyReal(polyReal)),
        changeAziendaRealTime: (aziendaRealTime) => dispatch(changeAziendaRealTime(aziendaRealTime)),
        changeLineaRealTime: (lineaRealTime) => dispatch(changeLineaRealTime(lineaRealTime)),
        changeRegioneAereoPartenza : (regioneAereoPartenza) => dispatch(changeRegioneAereoPartenza(regioneAereoPartenza)),
        changeRegioneAereoArrivo : (regioneAereoArrivo) => dispatch(changeRegioneAereoArrivo(regioneAereoArrivo)),
        changeLayerDrawer : (layerDrawer) => dispatch(changeLayerDrawer(layerDrawer)),
        changeLayerInformation : (layerInformation) => dispatch(changeLayerInformation(layerInformation)),
        changeLayerDiv : (layerDiv) => dispatch(changeLayerDiv(layerDiv)),
        changeArrayLayer : (arrayLayer) => dispatch(changeArrayLayer(arrayLayer)),
        changeLatLongLayer : (latLongLayer) => dispatch(changeLatLongLayer(latLongLayer)),
        changeMappa : (mappa) => dispatch(changeMappa(mappa))

    }
  }

export default  memo(connect(mapStateToProps,mapDispatchToProps)(ClickOnMap));
